import { useNavigate, Link } from 'react-router-dom';
import { openCalendly } from '../../lib/calendly';
import BsiqActionButton from './BsiqActionButton';
import { openApp } from '../../lib/siteUrls';

const BORDER = 'rgba(255,255,255,0.10)';
const TEXT_MUTED = '#B8C5D6';
const TEXT_LIGHT = '#7F90A7';

/**
 * SiteFooter — the marketing homepage footer, used on every public-facing
 * page (Home, Login, Register, and any other interior page).
 *
 * Section-anchor links (Features / How It Works / Atlas AI / Compare)
 * fall back to navigating to `/#<anchor>` when the user is on a page that
 * doesn't own those sections, so the click still works from /login, etc.
 */
const SiteFooter = () => {
  const navigate = useNavigate();
  const scrollTo = (id) => {
    const target = typeof document !== 'undefined' ? document.getElementById(id) : null;
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate(`/#${id}`);
    }
  };

  return (
    <footer
      className="px-6"
      style={{ backgroundColor: '#091426', borderTop: `1px solid ${BORDER}`, fontFamily: "'Public Sans', sans-serif" }}
      data-testid="landing-footer"
    >
      <div className="max-w-[1320px] mx-auto pt-14 pb-8">
        <div className="grid gap-12 lg:grid-cols-[1.1fr_1.9fr] lg:gap-20">
          <div>
            <Link to="/" className="flex w-fit items-center gap-3 rounded-sm bsiq-focus-ring" data-testid="footer-logo">
              <span className="inline-flex rounded-xl bg-white p-2"><img src="/bidsignaliq-logo.png?v=20261021" alt="" style={{ height: '38px', width: 'auto', display: 'block' }} /></span>
              <span className="font-bold text-lg tracking-tight text-white" style={{ letterSpacing: '-0.01em' }}>BidsignalIQ</span>
            </Link>
            <p className="mt-6 max-w-sm" style={{ color: TEXT_MUTED, fontSize: '14px' }}>
              The governed GovCon BD operating system for moving opportunities from signal and qualification through capture, execution, and organizational learning.
            </p>
            <div className="mt-7"><BsiqActionButton variant="gold" onClick={openCalendly} data-testid="footer-request-demo-btn">Request a demo</BsiqActionButton></div>
          </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-10">
          <div>
            <p className="text-xs font-semibold mb-4 uppercase text-white" style={{ letterSpacing: '0.08em' }}>Product</p>
            <ul className="space-y-2 text-sm" style={{ color: TEXT_MUTED }}>
              <li><button className="transition hover:text-white" onClick={() => scrollTo('oi')}>Features</button></li>
              <li><button className="transition hover:text-white" onClick={() => scrollTo('oi')}>How It Works</button></li>
              <li><button className="transition hover:text-white" onClick={() => scrollTo('atlas')}>Atlas</button></li>
              <li><button className="transition hover:text-white" onClick={() => scrollTo('compare')}>Trust &amp; Governance</button></li>
            </ul>
          </div>
          <div>
            <p className="text-xs font-semibold mb-4 uppercase text-white" style={{ letterSpacing: '0.08em' }}>Company</p>
            <ul className="space-y-2 text-sm" style={{ color: TEXT_MUTED }}>
              <li><a href="https://www.lenvargroup.com/" target="_blank" rel="noopener noreferrer" className="transition hover:text-white" data-testid="footer-lenvar-link">About Lenvar Group</a></li>
              <li><button className="transition hover:text-white" onClick={openCalendly}>Contact</button></li>
              <li><Link to="/trust-center" className="transition hover:text-white" data-testid="footer-trust-link">Trust Center</Link></li>
              <li><Link to="/privacy" className="transition hover:text-white" data-testid="footer-privacy-link">Privacy Policy</Link></li>
              <li><Link to="/terms" className="transition hover:text-white" data-testid="footer-terms-link">Terms of Service</Link></li>
            </ul>
          </div>
          <div>
            <p className="text-xs font-semibold mb-4 uppercase text-white" style={{ letterSpacing: '0.08em' }}>Access</p>
            <ul className="space-y-2 text-sm" style={{ color: TEXT_MUTED }}>
              <li><button className="transition hover:text-white" onClick={() => openApp('/register')}>Start trial</button></li>
              <li><button className="transition hover:text-white" onClick={openCalendly}>Request demo</button></li>
              <li><button className="transition hover:text-white" onClick={() => openApp('/login')}>Sign in</button></li>
            </ul>
          </div>
        </div>
        </div>

        <p className="text-center text-xs mt-12 pt-7" style={{ color: TEXT_LIGHT, borderTop: `1px solid ${BORDER}` }}>
          © 2026 <a href="https://www.lenvargroup.com/" target="_blank" rel="noopener noreferrer" className="text-slate-300 underline underline-offset-2 hover:text-white">Lenvar Global Pvt. Ltd.</a> All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default SiteFooter;
